import { createSlice } from '@reduxjs/toolkit';
import { autoParamsSchema } from '../types/autoUserSchema';
import { getMarks, getModels, getYears, getModifications } from '../services/fetchParamsAuto';
import { HYDRATE } from 'next-redux-wrapper';

const initialState: autoParamsSchema = {
  listMark: [],
  listModel: [],
  listYear: [],
  listModification: [],
};

export const autoParamsSlice = createSlice({
  name: 'autoParams',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload.autoParams,
      };
    });
    builder.addCase(getMarks.fulfilled, (state, action) => {
      if (action.payload) {
        state.listMark = action.payload;
      }
    });
    builder.addCase(getMarks.rejected, state => {
      state.listMark = [];
    });

    builder.addCase(getModels.fulfilled, (state, action) => {
      if (action.payload) {
        state.listModel = action.payload;
      }
    });
    builder.addCase(getModels.rejected, state => {
      state.listModel = [];
    });

    builder.addCase(getYears.fulfilled, (state, action) => {
      if (action.payload) {
        state.listYear = action.payload?.map(x => x + '');
      }
    });
    builder.addCase(getYears.rejected, state => {
      state.listYear = [];
    });

    builder.addCase(getModifications.fulfilled, (state, action) => {
      if (action.payload) {
        state.listModification = action.payload;
      }
    });
    builder.addCase(getModifications.rejected, state => {
      state.listModification = [];
    });
  },
});

export const { actions: autoParamsActions } = autoParamsSlice;
